

















































































































































































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IOrder } from "@/models/orders";
import { DataModules } from "@/store/modules/data";
import BillingCyclesStore from "@/mixins/constants/billingCyclesStore";
import Context from "@/mixins/context";
import { IAppliedTax } from "@/models/tax";
import { ClientRoutes } from "@/data/enums/router";

@Component({
  components: {
    "product-tags": () => import("@/components/app/global/tags/productTags.vue")
  }
})
export default class OrderItems extends Mixins(BillingCyclesStore, Context) {
  // Props
  @Prop({ required: true })
  public order!: IOrder;

  // Data
  public selectedOrderItems: any[] = [];

  public get isLoading() {
    return this.$_.isEmpty(this.order);
  }

  // Getters

  public get mappedProductImages() {
    return this.$_.mapValues(
      this.$_.keyBy(
        this.$_.get(this.order, "products", []),
        product => product.product.id
      ),
      "product.image.full_url"
    );
  }

  public get mappedProductTags() {
    return this.$_.mapValues(
      this.$_.keyBy(
        this.$_.get(this.order, "products", []),
        product => product.product.id
      ),
      "tags"
    );
  }

  public get orderItems() {
    const _ = this.$_;
    const items: any[] = [];
    this.$_.forEach(
      _.get(this.order, "current_data.content.products", []),
      product => {
        const item = {
          id: product.id,
          brandId: product.product.brand_id,
          name: product.product.name_translated || product.product.name,
          category:
            product.product.category.name_translated ||
            product.product.category.name,
          quantity: product.quantity,
          total: product.configuration_net_amount_formatted,
          sellingPrice: product.configuration_net_selling_price_formatted,
          qtyBasedSubItems: [] as any[],
          nonQtyBasedSubItems: [] as any[],
          isSubscription: !!product.billing_cycle_months,
          billingCycle: this.getBillingCycleName(product.billing_cycle_months),
          image: this.$_.get(
            product,
            "product.image.full_url",
            _.get(this.mappedProductImages, product.product.id)
          ),
          to: {
            name: this.isAdmin
              ? "admin__clientCProd"
              : this.isMockClientContext
              ? "admin__upmindClientCProd"
              : ClientRoutes.CONTRACT_PRODUCT,
            params: {
              clientId: this.order.client_id,
              productId: product.contracts_product_id,
              contractId: this.order.contract_id
            }
          },
          tags: _.get(this.mappedProductTags, product.product.id, []),
          product: product
        };

        // Add options
        _.forEach(product.options, option => {
          const subProduct = _.get(option, "product");
          item[
            option.quantity === product.quantity
              ? "qtyBasedSubItems"
              : "nonQtyBasedSubItems"
          ].push({
            id: option.id,
            name: `${subProduct.category.name_translated}: ${subProduct.name_translated}`,
            quantity: option.quantity,
            unit_quantity: _.get(option, "unit_quantity", 1),
            total: option.net_selling_price_formatted,
            sellingPrice: option.net_unit_selling_price_formatted,
            subItem: true,
            isOption: true
          });
        });

        // Add attributes
        _.forEach(product.attributes, attribute => {
          const subProduct = _.get(attribute, "product");
          item.qtyBasedSubItems.push({
            id: attribute.id,
            name: `${subProduct.category.name_translated}: ${subProduct.name_translated}`,
            quantity: attribute.quantity,
            unit_quantity: _.get(attribute, "unit_quantity", 1),
            total: "",
            subItem: true,
            isAttribute: true
          });
        });

        // Add product discounts
        const productPromotions = _.get(product, "promotions", []);
        const appliedPromotions = (
          _.get(
            this.order,
            "current_data.content.promotions",
            _.get(this.order, "promotions")
          ) || []
        )
          .map(p => {
            const productPromotion = productPromotions.find(
              pp => pp.promotion_id === p.promotion.id && !p.promotion.global
            );
            return {
              ...p,
              productPromotion
            };
          })
          .filter(p => !!p.productPromotion);

        _.forEach(appliedPromotions, promotion => {
          item.nonQtyBasedSubItems.push({
            id: promotion.id,
            name: `${this.$t("_.promotion")}: ${promotion.promotion.code}`,
            total: `${promotion.productPromotion.net_amount_formatted}`,
            subItem: true
          });
        });

        if (item.qtyBasedSubItems.length || item.nonQtyBasedSubItems.length) {
          item.qtyBasedSubItems.unshift({
            id: `sub-${product.id}`,
            name: product.product_name,
            quantity: product.quantity,
            total: product.configuration_net_amount_formatted,
            sellingPrice: product.net_unit_selling_price_formatted,
            subItem: true
          });
        }

        items.push(item);
      }
    );

    return items;
  }

  public get orderPromotions() {
    return this.$store.getters[`data/${DataModules.INVOICES}/mappedPromotions`](
      this.order
    );
  }

  public get defaultSelectionState() {
    return this.selectedOrderItems.length === this.orderItems.length;
  }

  public get indeterminateSelectionState() {
    return !!(
      this.selectedOrderItems.length &&
      this.selectedOrderItems.length !== this.orderItems.length
    );
  }

  // Methods

  public getAppliedTaxTagName(tax: IAppliedTax) {
    return this.$store.getters[
      `data/${DataModules.TAX_TAGS}/computeAppliedTagName`
    ](tax.tax_tag_data?.[0]);
  }

  public toggleAll(checked) {
    if (checked) this.selectedOrderItems = [...this.orderItems];
    else this.selectedOrderItems = [];
  }

  public openTagSelectModal(isAdd = false) {
    const activeTags = this.$_.flatten(
      this.selectedOrderItems?.map(i => i.tags)
    );

    return this.$store.dispatch(`data/${DataModules.TAGS}/openSelectModal`, {
      props: {
        activeTags: isAdd ? [] : activeTags,
        brandId: this.order.brand_id
      },
      events: {
        success: tags => {
          this.selectedOrderItems.map(product => {
            const newTags = isAdd
              ? this.$_.unionBy(product?.tags, tags, "id")
              : this.$_.filter(product.tags, tag =>
                  tags.map(i => i.id).includes(tag.id)
                );

            return this.assignTags(
              product.id,
              newTags.map(i => i.id)
            );
          });

          this.reloadOrder();
          this.selectedOrderItems = [];
        }
      }
    });
  }

  public assignTags(productId, tagIds) {
    return this.$store.dispatch(`data/${DataModules.ORDERS}/syncProductTags`, {
      id: productId,
      data: {
        tag_ids: tagIds
      }
    });
  }

  public reloadOrder() {
    this.$emit("reload-order");
  }

  public onToggleProduct(product, checked) {
    if (checked) {
      this.selectedOrderItems = this.$_.union(this.selectedOrderItems, [
        product
      ]);
    } else {
      const index = this.$_.findIndex(
        this.selectedOrderItems,
        i => i.id === product.id
      );
      this.selectedOrderItems &&
        index > -1 &&
        this.selectedOrderItems.splice(index, 1);
    }
  }
}
